(function($){

	const {isIOS} = window.Helpers;
	const {ajax_url, nonce} = window.themeSettings;

	class Search {
		constructor() {
			this.xhr = null;

			this.elements = {
				searchContainer: $('.site-header__search'),
				searchForm: $('.site-header__search form'),
				searchButton: $('.site-header__search-button button'),
				searchInput: $('.site-header__search input[name="search"]'),
				searchResultsWrap: $('.site-header__search-results-wrap'),
				searchResults: $('.site-header__search-results'),
				siteHeader: $('.site-header')
			};

			this.init();
		}

		init() {
			const {searchButton, searchInput, siteHeader, searchForm} = this.elements;

			searchButton.on('click', () => {
				if (this.shownTimeout) {
					clearTimeout(this.shownTimeout);
				}

				if (this.active) {
					this.hide();
				} else {
					this.show();
				}
			});

			searchInput.on('focus', () => {
				siteHeader.addClass('search--focused');
			});

			searchInput.on('blur', () => {
				siteHeader.removeClass('search--focused');
			});

			searchForm.on('submit', (ev) => {
				ev.preventDefault();
				this.search();
			});

			const debounceSearchInput = Helpers.debounce(() => {
				this.search();
			}, 500);

			searchInput.on('input', () => debounceSearchInput());

			$(window).on('show-mobile-menu', () => this.hide());
		}

		show() {
			const {siteHeader, searchContainer, searchButton, searchInput} = this.elements;

			siteHeader.addClass('search--active');
			searchContainer.addClass('is-active');
			searchButton.addClass('is-active');

			this.shownTimeout = setTimeout(() => {
				siteHeader.addClass('search--shown');
			}, 200);

			if (!isIOS()) {
				setTimeout(() => {
					searchInput.get(0).focus();
				}, 200);
			}


			this.active = true;

			$(window).trigger('show-search');
		}

		hide() {
			const {siteHeader, searchContainer, searchButton, searchResultsWrap, searchInput} = this.elements;

			siteHeader.removeClass('search--active');
			searchContainer.removeClass('is-active');
			searchButton.removeClass('is-active');

			// hide results
			searchResultsWrap.removeClass('is-active');

			siteHeader.removeClass('search--shown');

			searchInput.val('');

			this.active = false;
		}

		search() {
			const {searchContainer, searchResultsWrap, searchResults, searchInput} = this.elements;

			this.searchQuery = searchInput.val().trim();

			searchResultsWrap.removeClass('is-active');
			searchResults.html('');

			if (this.searchQuery.length < 2) {
				return;
			}

			searchContainer.addClass('is-loading');

			if (this.xhr) {
				this.xhr.abort();
			}

			this.xhr = $.ajax({
				url: ajax_url,
				type: 'POST',
				data: {
					action: 'site_search',
					search: this.searchQuery,
					nonce: nonce
				},
				success: (response) => {
					searchResults.html(response['data']['html']);
				},
				complete: () => {
					searchContainer.removeClass('is-loading');
					searchResultsWrap.addClass('is-active');
				}
			});
		}
	}

	class MobileMenu {
		constructor() {
			this.init();
		}

		init() {
			$('.site-header__menu-button button').on('click', () => {
				if (this.active) {
					this.hide();
				} else {
					this.show();
				}
			});

			$(window).on('show-search', () => this.hide());
		}

		show() {
			$('.site-header').addClass('menu--open');
			$('.site-header__mobile-menu').addClass('is-active');
			$('.site-header__menu-button button').addClass('is-active');

			this.active = true;

			$(window).trigger('show-mobile-menu');
		}

		hide() {
			$('.site-header').removeClass('menu--open');
			$('.site-header__mobile-menu').removeClass('is-active');
			$('.site-header__menu-button button').removeClass('is-active');

			this.active = false;
		}
	}

	function headerCls() {
		const scroll = $(window).scrollTop();

		if (scroll >= 1) {
			$(".site-header").addClass("header--scrolled");
		} else {
			$(".site-header").removeClass("header--scrolled");
		}
	}

	const headerClsThrottled = Helpers.throttle(headerCls, 100, {trailing: true});
	$(window).on('scroll', headerClsThrottled);

	headerCls();

	window.search = new Search();
	window.mobileMenu = new MobileMenu();

})(jQuery);

